export const errorPageView = statusCode => ({
  type: `Views ${statusCode} error page`,
  data: {
    statusCode,
  },
});
